import { setSelectedElementKey, setShowContextMenu } from "@/store/iframeSlice";
import {
  useCanvasStore,
  useSelectedNavTreeNode,
} from "@/components/Canvas/stores/canvasStore";
import { TempoElement } from "@/utils/tempoElement";
import { isChrome } from "@/utils/browserDetection";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

export const useCanvasContextMenu = (storyboardId?: string) => {
  const dispatch = useDispatch();
  const { selectedElement } = useSelectedNavTreeNode();

  const selectedElementRef = useRef(selectedElement);
  useEffect(() => {
    selectedElementRef.current = selectedElement;
  }, [selectedElement]);

  const storyboardIdRef = useRef(storyboardId);
  useEffect(() => {
    storyboardIdRef.current = storyboardId;
  }, [storyboardId]);

  const callContextMenu = useCallback(
    (clientX: number, clientY: number, storyboardId?: string) => {
      // Don't show context menu for empty canvas on non-Chrome browsers
      if (!storyboardId && selectedElementRef.current.isEmpty() && !isChrome) {
        return;
      }

      useCanvasStore.getState().setMenu(clientX, clientY);
      dispatch(setShowContextMenu(true));

      if (storyboardId && selectedElementRef.current.isEmpty()) {
        dispatch(
          setSelectedElementKey(
            TempoElement.forStoryboard(storyboardId).getKey(),
          ),
        );
      }
    },
    [dispatch],
  );

  const handleContextMenu = useCallback(
    (e: any) => {
      e.preventDefault();
      e.stopPropagation();

      callContextMenu(e.clientX, e.clientY, storyboardIdRef.current);
    },
    [callContextMenu],
  );

  return { handleContextMenu, callContextMenu };
};
